<template>
  <div class="p-b-5">
    <RemoveAssetModal
      :show-modal="showModal"
      :asset-id="showModalId"
      :asset-name="showModalName"
      @remove-asset="removeAsset(showModalId)"
      @hide-modal="hideModal"
    />
    <v-table
      :data="assetsList"
      :current-page.sync="currentPage"
      :page-size="20"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            v-t="'ASSETS_TABLE_ROW_NAME'"
            sort-key="originalFileName"
          />
          <v-th
            v-t="'ASSETS_TABLE_ROW_FORMAT'"
            sort-key="contentType"
          />
          <th
            v-t="'ASSETS_TABLE_RECORDING'"
            class="text-center"
          />
          <th v-t="'TABLE_COL_ACTIONS'" />
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>{{ row.originalFileName }}</td>
          <td>
            {{ row.contentType }}
          </td>
          <td class="text-center">
            <RecordingButton :recording-url="row.publicUrl" />
          </td>
          <td>
            <div class="actions-collapsed-list">
              <div class="action-icon">
                <a
                  class="btn btn-list-function"
                  href="javascript:;"
                  @click="showRemoveAsset(row.id, row.originalFileName)"
                >
                  <i
                    class="typcn typcn-trash"
                    aria-hidden="true"
                  />
                  <span
                    v-t="'DELETE'"
                    class="hint-text-mobile"
                  />
                </a>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </v-table>
    <div class="pagination-min">
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :max-page-links="10"
        />
      </div>
    </div>

    <div
      v-if="getAssetsStatus.status === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'ASSETS_TABLE_LOADING'" />
    </div> 
    <div
      v-if="
        getAssetsStatus.status === 'success' && assetsList &&
          assetsList.length === 0
      "
      v-t="'ASSETS_TABLE_EMPTY'"
      class="well well-sm text-center"
    /> 
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import messages from '../locales';
import sharedMessages from '@/core/locales';
import Loader from '@/core/components/Loader';
import RecordingButton from '@/modules/viewAssets/components/RecordingButton';
import RemoveAssetModal from '@/modules/viewAssets/components/RemoveAssetModal';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { STATUS_ERROR, STATUS_SUCCESS, getStatus } from '@/store/helpers';

export default {
  name: 'AudioAssets',
  components: {
    Loader,
    RecordingButton,
    RemoveAssetModal,
  },
  props: {
    targetId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data: function () {
    return {
      currentPage: 1,
      totalPages: 0,
      showModal: false,
      showModalId: '',
      showModalName: ''
    };
  },
  computed: {
    ...mapState('assets', ['assetsList']),
    ...mapState('assets', {
      getAssetsStatus: (state) => getStatus(state, 'getAssets') || {},
      deleteAssetStatus: (state) => getStatus(state, 'deleteAsset') || {},
    }),
  },
  created() {
    this.getAssets();
  },
  methods: {
    ...mapActions('assets', ['getAssets', 'deleteAsset', 'getAssetReferences']),
    async removeAsset(id) {
      await this.deleteAsset(id);
      if (this.deleteAssetStatus.status === STATUS_SUCCESS) {
        utilities.showToaster('success', this.$i18n.t('DELETE_ASSET_SUCCESS'));
      }
      if (this.deleteAssetStatus.status === STATUS_ERROR) {
        utilities.showToaster('error', this.$i18n.t('DELETE_ASSET_FAILURE'));
      }
      this.hideModal();
    },
    showRemoveAsset(id, name) {
      this.getAssetReferences(id);
      this.showModalId = id;
      this.showModalName = name;
      this.showModal = true;
    },
    hideModal() {
      this.showModal = false;
    } 
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en',
  },
};
</script>

<style>
</style>